/**
 * WordPress dependencies
 */
import { Component, Fragment } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import ColorOptions from '../../../extensions/controls/color-options';

/**
 * Inspector controls
 */
class Inspector extends Component {
	render() {
		return <Fragment>
			<InspectorControls>
				<ColorOptions { ...this.props } />
			</InspectorControls>
		</Fragment>;
	}
}

export default Inspector;
